// Region-specific service destinations, matching the customer LP routing.
export const getServiceUrl = locale => {
  if (locale === 'zh-TW') return 'https://japan-toreca.com/tw/lp';
  if (locale === 'zh-HK') return 'https://japan-toreca.com/hk/lp';
  return locale === 'ja'
    ? 'https://japan-toreca.com/lp'
    : 'https://japan-toreca.com/lp/en';
};
